import { render, staticRenderFns } from "./tab4-security.vue?vue&type=template&id=64a1fbcc&scoped=true&"
import script from "./tab4-security.vue?vue&type=script&lang=js&"
export * from "./tab4-security.vue?vue&type=script&lang=js&"
import style0 from "./tab4-security.vue?vue&type=style&index=0&id=64a1fbcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a1fbcc",
  null
  
)

export default component.exports